export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4980.6dc62bc9.jpg";